// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__32t8H","left":"StickyBox_left__2svn0","right":"StickyBox_right__3p-kW"};